export const API_ENDPOINT = "https://hiltonglobal.in/wp-json/wp/v2";
export const SENDGRID_API_URL = "https://api.sendgrid.com/v3/mail/send";
export const SENDGRID_API_KEY =
  "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";
export const receivermail = "info@hiltonglobal.in"; //to mail
export const sendermail = "info@hiltonglobal.in"; //from mail
export const recaptchakey = "6Lf5n8UUAAAAAGNFoBMXG4qabmkPW4JmLBQYStY8";
